export default __webpack_public_path__ + "static/O0320-4055ec7cd5c4bdf30f956a03262d5416.png";